import NotFoundContainer from 'modules/general/containers/NotFoundContainer';

const NotFoundView = () => <NotFoundContainer />;

export default NotFoundView;
